import { GoogleIcon, InstagramIcon, TikTokIcon } from '../Icons';
import OverviewCardWrapper from './OverviewCardWrapper';
import { TableRowBody } from '../DataVis/DataTable/styledComponents';
import { getScoreColor } from 'utils/helpers';
import styled from 'styled-components';

const MetricStatWrapper = styled.span`
    font-weight: ${({ theme }) => theme.fontBold};
    color: ${({ theme }) => theme.gray_3};
    font-size: ${({ theme }) => theme.fontSize_sm};
    line-height: ${({ theme }) => theme.fontSize_base};
    display: flex;
    align-items: center;
    gap: 0.25rem;
`;

const Metric = styled.span`
    text-transform: uppercase;
`;

const OverviewCardGoogleIcon = styled(GoogleIcon)`
    color: ${({ theme }) => theme.google_blue};
    ${OverviewCardWrapper}:not(:hover):not(:focus-visible) & {
        color: ${({ theme }) => theme.gray_600};
    }
`;

const OverviewCardTikTokIcon = styled(TikTokIcon)`
    color: ${({ theme }) => theme.tiktok_pink};
    ${OverviewCardWrapper}:not(:hover):not(:focus-visible) & {
        color: ${({ theme }) => theme.gray_600};
    }
`;

const OverviewCardInstagramIcon = styled(InstagramIcon)`
    color: ${({ theme }) => theme.instagram_orange};
    ${OverviewCardWrapper}:not(:hover):not(:focus-visible) & {
        color: ${({ theme }) => theme.gray_600};
    }
`;

export const CardStatIcon = styled.span`
    font-size: ${({ theme }) => theme.space_9}px;
    line-height: ${({ theme }) => theme.space_10}px;
    color: ${({ score, metricLabel }) =>
        getScoreColor(score, false, metricLabel)};

    ${OverviewCardWrapper}:not(:hover):not(:focus-visible) & {
        color: ${({ theme }) => theme.gray_600};
    }
    ${TableRowBody}:not(:hover):not(:focus-visible) & {
        color: ${({ theme }) => theme.gray_600};
    }
`;

function MetricStat({
    dataSource,
    metric,
    metricLabel,
    showIcon = true,
    ...props
}) {
    return (
        <MetricStatWrapper {...props}>
            {dataSource === 'GOOGLE' && showIcon ? (
                <OverviewCardGoogleIcon />
            ) : null}
            {dataSource === 'TIKTOK' && showIcon ? (
                <OverviewCardTikTokIcon />
            ) : null}
            {dataSource === 'INSTAGRAM' && showIcon ? (
                <OverviewCardInstagramIcon />
            ) : null}
            <span>
                <Metric>{metric || '—'}</Metric>{' '}
                <span
                    css={`
                        display: inline-block;
                    `}
                >
                    {metricLabel}
                </span>
            </span>
        </MetricStatWrapper>
    );
}

export default MetricStat;
